export default {
  Postings: {
    Outdated: {
      POSTED:
        'This calculation has been updated since these were posted. Please edit and re-submit to Xero.',
      LOCKED:
        'This calculation should be updated. Please re-open to re-calculate.',
    },
    POSTING_INTO: 'Posting {{type}} into {{name}}',
    POSTED_INTO: 'Posted {{type}} into {{name}}',
    VOIDED_IN_XERO:
      '**This has been voided in Xero.** When you post, Mayday will create a new {{type}}',
    POST_AS_XERO_STATE:
      "If you update this posting in Mayday, the status (i.e. approved or draft) in Xero will not change. Similarly, any changes made to this posting's status within Xero will not affect its status in Mayday.",
    POST_AS_XERO_STATE_DIFFERENT:
      "These two postings have different states in Xero. If you update them in Mayday, their status (i.e. approved or draft) in Xero will not change. Similarly, any changes made to these postings' statuses within Xero will not affect their statuses in Mayday.",
    POST: 'Post to Xero',
    POSTED: 'Posted as {{type}}',
    POSTED_MARKED_PAID: 'Posted as {{type}} and marked as paid',
    INVALID:
      'There were validation errors with the posting. Please rectify and try again',
    ERROR_XERO: 'Xero rejected the postings for the following reasons:',
    MARK_AS_PAID_ERROR:
      'Your invoice & bill were successfully posted to Xero but the selected posting(s) could not be marked as paid for the following reasons:',
    ERROR_RECREATE:
      'If the postings have been deleted in Xero, please use the "Recreate" button',
    LOCK_DATE: 'This date is before the lock date in {{entity}}',
    LOCK_DATE_DRAFT:
      'Only a draft can be posted because one or more entities are locked',
    FORCED_JOURNAL_CURRENCY:
      'Journals must be posted since the two entities do not share a currency',
    FORCED_JOURNAL_NEGATIVE:
      'Journals must be posted since Xero does not allow invoices with negative totals',
    FORCED_CURRENCY:
      'The invoice and bill must be posted in {{currency}} since that is the only common currency',
    SELECT_TAX: 'Select a tax rate',
    MARK_POSTED: 'Mark this {{type}} as paid to',
    POSTED_DISABLED: 'Only authorised postings can be marked as paid',
    RECREATE: 'Recreate',
    RECREATE_HEADER: 'Are you sure you want to recreate these postings?',
    RECREATE_DESCRIPTION_1:
      'If the current postings haven\'t been voided in Xero, recreating them will create duplicates. You can check if the current postings are voided by using the "View in Xero" buttons on this page. ',
    RECREATE_DESCRIPTION_2:
      'If you simply want to update these postings, use the "Update in Xero" button, which will edit the postings in place rather than creating new ones.',
    TAX_RATE: 'Tax Rate',
    NARRATION: 'Narration',
    SUBTOTAL: 'Subtotal',
    TAX: 'Tax',
    INCLUDES_TAX: 'Includes Tax of',
    TOTAL: 'Total',
    ADD_LINE: '+ Add line',
    JOURNAL_BALANCE_ERROR: 'Total credits must equal total debits',
    Notice: {
      Validation: {
        TITLE: 'Validation failed',
        BODY: 'Xero rejected the invoice due to some errors. Please rectify and re-submit',
      },
      Error: {
        TITLE: 'Oh no!',
        BODY: 'There was an error posting to Xero. Please try again later or get in touch with us using the chat bot in the bottom-right corner',
      },
      Tooltip: {
        INVOICE_BILL:
          'Posting as Invoice & Bill is not available on your current plan',
        GROUPING:
          'Grouping by transaction is not available on your current plan',
      },
    },
    Types: {
      journal: 'Journal',
      invoice: 'Invoice',
      bill: 'Bill',
    },
    Options: {
      CREATE: 'Create',
      POST_AS: 'Post as',
      CURRENCY: 'Currency',
      INVOICE_NUMBER: 'Invoice number',
      GROUP_BY: 'Group by',
    },
    Dates: {
      DATE: 'Date',
      ISSUE: 'Issue date',
      DUE: 'Due date',
    },
    TaxHandling: {
      TITLE: 'Lines are',
      PURCHASE: 'Tax inclusive',
      SALES: 'Tax exclusive',
    },
  },
};
